import { Module } from 'vuex';
import { School } from '@/types';

import scholenRepository from '@/repositories/scholenRepository';

import filterService from '@/services/filterService';
import { getLocationByZipcode } from '@/repositories/locationRepository';
import { getDistance, Location } from '@/services/locationService';
import queryLib from '@/library/queryLib';
import { RootState } from './types';

export type ScholenState = {
	scholen: School[];
	scholenLoading: boolean;

	schoolDistances?: {
		[key: string]: number; // <brin: kms>
	};
}
export default {
	namespaced: true,
	state: {
		scholen: [],
		scholenLoading: true,
		schoolDistances: undefined,
	},
	getters: {
		scholen(state) {
			return state.scholen;
		},
		scholenLoading(state) {
			return state.scholenLoading;
		},
		/**
		 * This getter will always return the list of filtered scholen based on the
		 * VUEX filter values of the filters. This could be changed to a less
		 * dynamic field; by explicitly computing the filteredScholen rather than
		 * having a getter deal with it.
		 */
		filteredScholen(state, getters, rootState, rootGetters) {
			const filter = rootGetters['filter/filterValues'];
			const filteredScholen = filterService.filterScholen(state.scholen, filter);
			return filteredScholen;
		},
		sortedFilteredScholen(state, getters) {
			const sortKey = state.schoolDistances ? 'distance' : 'naam';
			const sortedFilteredScholen = [...getters.filteredScholen].sort((a: School, b: School) => {
				const aValue = a[sortKey];
				const bValue = b[sortKey];

				if (!aValue || !bValue) {
					return -1;
				}

				const aNum = parseFloat(aValue as string);
				const bNum = parseFloat(bValue as string);

				if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
					return aNum - bNum;
				}
				if (aValue > bValue) {
					return 1;
				}
				return -1;
			});

			return sortedFilteredScholen;
		},
	},
	mutations: {
		// this contains all scholen
		setScholen(state, scholen: School[]) {
			state.scholen = scholen;
			state.scholenLoading = false;
		},
		setSchoolDistances(state, schoolDistances: { [key: string]: number }) {
			state.schoolDistances = schoolDistances;

			const newScholen = [] as School[];
			state.scholen.forEach((school) => {
				if (school.brin in schoolDistances) {
					// eslint-disable-next-line no-param-reassign
					newScholen.push({ ...school, distance: schoolDistances[school.brin] });
				}
			});
			state.scholen = newScholen;
		},
	},
	actions: {
		async loadScholen({
			state, getters, dispatch, commit,
		}) {
			if (state.scholen.length) {
				return getters.scholen;
			}

			const scholen = (await scholenRepository.listScholen()).data;

			// scholen.forEach((school) => {
			// 	if (school.ondersteuningsaanbod.length){
			// 		console.log(school);
			// 	}
			// })

			commit('setScholen', scholen);

			const queryParams = queryLib.getQueryParams();
			if ('postcode' in queryParams) {
				dispatch('updateSchoolDistances', queryParams.postcode);
			}
			return getters.scholen;
		},
		async updateSchoolDistances({ getters, commit }, zipcode: string) {
			const isValidZipcode = !!(zipcode.match(/[0-9]{4}(\s)*[a-zA-Z]{2}/));
			if (!isValidZipcode) {
				console.log('Ongeldige postcode');
				return;
			}

			const scholenLocaties = getters.scholen.map((school: School) => (
				{ brin: school.brin, location: { lat: school.lat, lng: school.lon } }
			));

			const myLocation = await getLocationByZipcode(zipcode);
			const schoolDistances: any = {};
			scholenLocaties.forEach((s: { brin: string; location: Location }) => {
				const schoolDistance = getDistance(myLocation, s.location);
				schoolDistances[s.brin] = schoolDistance;
			});

			commit('setSchoolDistances', schoolDistances);
		},
	},
} as Module<ScholenState, RootState>;
